<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Gerenciamento Transporte</h4>
              <a class="heading-elements-toggle"
                ><i class="fa fa-ellipsis-v font-medium-3"></i
              ></a>
              <div class="heading-elements">
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onFilterReset()"
                      v-b-tooltip
                      title="Atualizar listagem"
                      ><i class="ft-rotate-cw"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreenFw()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHideFw()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(1, null, false)"
                      v-b-tooltip
                      title="Ativar Registros"
                      v-if="getPermissionFw('gerenciamentotransporte.status')"
                      ><i class="fa fa-thumbs-o-up"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onActivateDesactivate(2, null, false)"
                      v-b-tooltip
                      title="Inutilizar Registros"
                      v-if="getPermissionFw('gerenciamentotransporte.status')"
                      ><i class="fa fa-thumbs-o-down"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'b_arquivo'">
                  </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/gerenciamentotransporte"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    track-by="carga_id"
                    pagination-path=""
                    @vuetable:load-error="onError"
                    @vuetable:cell-clicked="onDetail"
                    detail-row-component="gerenciamentotransporte-detalhes"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:loaded="onLoaded"
                  >
                    <template slot="num_romaneio" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.carga_doc[0].doc_carga_doc != null &&
                          props.rowData.carga_doc[0].doc_carga_doc.doc !=
                            null &&
                          props.rowData.carga_doc[0].doc_carga_doc.doc
                            .manifesto_doc != null
                        "
                        >{{
                          props.rowData.carga_doc[0].doc_carga_doc.doc
                            .manifesto_doc.num_fiscal
                        }}</span
                      >
                      <span
                        v-if="
                          props.rowData.carga_doc[0].doc_carga_doc != null &&
                          props.rowData.carga_doc[0].doc_carga_doc.doc !=
                            null &&
                          props.rowData.carga_doc[0].doc_carga_doc.doc
                            .manifesto_doc == null
                        "
                        >{{
                          props.rowData.carga_doc[0].doc_carga_doc.doc
                            .num_fiscal
                        }}</span
                      >
                    </template>
                    <template slot="ciot" slot-scope="props">
                      <span v-if="props.rowData.carga_ciot != null">{{
                        props.rowData.carga_ciot.ciot.ciot
                      }}</span>
                    </template>
                    <template slot="placa_primaria" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.carga_meio_transp != null &&
                          props.rowData.carga_meio_transp
                            .veiculo_motorista != null
                        "
                        >{{
                          props.rowData.carga_meio_transp
                            .veiculo_motorista.veiculo.placa
                        }}</span
                      >
                    </template>
                    <template slot="motorista" slot-scope="props">
                      <span
                        v-if="
                          props.rowData.carga_meio_transp != null &&
                          props.rowData.carga_meio_transp
                            .veiculo_motorista != null
                        "
                        >{{
                          props.rowData.carga_meio_transp
                            .veiculo_motorista.pessoa_motorista.pessoa_fisica
                            .nome
                        }}</span
                      >
                    </template>
                    <template slot="vlr_total_pedagio" slot-scope="props">
                      <span v-if="props.rowData.carga_rota !== null">{{
                        formatNumber(
                          props.rowData.carga_rota.valor_total_pedagio
                        )
                      }}</span>
                    </template>
                    <template slot="status" slot-scope="props">
                      <span
                        class="badge badge-warning"
                        v-if="props.rowData.status.valor == 1"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-success"
                        v-if="props.rowData.status.valor == 2"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-info"
                        v-if="props.rowData.status.valor == 3"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-danger"
                        v-if="props.rowData.status.valor == 4"
                        >{{ props.rowData.status.descr }}</span
                      >
                      <span
                        class="badge badge-secundary"
                        v-if="props.rowData.status.valor == 5"
                        >{{ props.rowData.status.descr }}</span
                      >
                    </template>

                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <span
                          v-if="
                            getPermissionFw('gerenciamentotransporte.status')
                          "
                        >
                          <a
                            v-if="props.rowData.status.valor == 2"
                            @click="
                              onActivateDesactivate(1, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Ativar"
                            ><i class="fa fa-thumbs-o-up"></i
                          ></a>
                          <a
                            v-if="props.rowData.status.valor == 1"
                            @click="
                              onActivateDesactivate(2, props.rowData, true)
                            "
                            v-b-tooltip
                            title="Inativar"
                            ><i class="fa fa-thumbs-o-down"></i
                          ></a>
                        </span>
                        <a
                          @click="onPrintRomaneio(props.rowData)"
                          v-if="
                            props.rowData.tp_operacao_principal.valor == 3 &&
                            props.rowData.status_processo_expedicao.valor == 3
                          "
                          v-b-tooltip
                          title="Imprimir romaneio"
                          ><i class="fa fa-file"></i
                        ></a>
                        <a
                          @click="onExport(props.rowData.carga_id)"
                          v-b-tooltip
                          title="Exportar NFs"
                          ><i class="fa fa-file-code-o"></i
                        ></a>
                        <span
                          v-if="
                            getPermissionFw(
                              'gerenciamentotransporte.adiantamento'
                            )
                          "
                        >
                          <a
                            @click="onAdiantar(props.rowData.carga_id)"
                            v-b-tooltip
                            title="Adiantar Valor"
                            ><i class="fa fa-money"></i
                          ></a>
                        </span>
                        <span
                            v-if="
                            getPermissionFw(
                              'gerenciamentotransporte.transferenciainterna'
                            )
                          "
                        >
                          <a
                              @click="onTransferencia(props.rowData.carga_id)"
                              v-b-tooltip
                              title="Transferencia Interna"
                          ><i class="fa fa-exchange"></i
                          ></a>
                        </span>
                        <a
                          @click="onDetail(props.rowData, null, null)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                        ref="paginationInfo"
                        :css="css.pagination"
                        info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                        ref="pagination"
                        :css="css.pagination"
                        @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <GerenciamentoTransporteForm
        ref="gerenciamentotransporteform"
        :metodo="onFilterReset"
        :tabela="'carga'"
        :rota="'gerenciamentotransporte'"
      >
      </GerenciamentoTransporteForm>
      <GerenciamentoTransporteExportacao
        ref="gerenciamentotransporteexportacao"
        :rota="'gerenciamentotransporte'"
      />
      <GerenciamentoTransporteAdiantamento
        ref="gerenciamentotransporteadiantamento"
      />
    </div>
  </div>
</template>
<script>
import accounting from "accounting";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import GerenciamentoTransporteFilterBar from "./GerenciamentoTransporteFilterBar";
import GerenciamentoTransporteForm from "./GerenciamentoTransporteForm";
import GerenciamentoTransporteDetalhes from "./GerenciamentoTransporteDetalhes";
import GerenciamentoTransporteExportacao from "./GerenciamentoTransporteExportacao.vue";
import GerenciamentoTransporteAdiantamento from "./GerenciamentoTransporteAdiantamento.vue";

Vue.component(
  "gerenciamentotransporte-detalhes",
  GerenciamentoTransporteDetalhes
);

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    GerenciamentoTransporteForm,
    GerenciamentoTransporteExportacao,

    GerenciamentoTransporteAdiantamento,
    "vuetable-filterbar": GerenciamentoTransporteFilterBar,
  },
  data() {
    return {
      dataExport: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      form: new Form({ num_carga: "", carga_id: "", status: [] }),
      helpForm: new Form({ recordCollection: [], status: "" }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "num_carga",
          title: "N° Carga",
          sortField: "num_carga",
        },
        {
          name: "__slot:num_romaneio",
          title: "MDFE/N° Romaneio",
          sortField: "num_romaneio",
        },
        {
          name: "__slot:placa_primaria",
          title: "Placa",
          sortField: "placa_primaria",
        },
        {
          name: "__slot:motorista",
          title: "Motorista",
          sortField: "motorista",
        },
        {
          name: "__slot:ciot",
          title: "Ciot",
          sortField: "ciot",
        },
        {
          name: "__slot:vlr_total_pedagio",
          title: "Valor total dos pedágios",
          sortField: "vlr_total_pedagio",
        },
        {
          name: "__slot:status",
          title: "Status",
          sortField: "status",
        },
        {
          name: "__slot:actions", // <----
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function () {
      self.onFilterReset();
    });
  },
  methods: {
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.carga_id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        num_carga: data_filter.num_carga,
        dt_ini: data_filter.dt_ini,
        dt_fim: data_filter.dt_fim,
        num_romaneio: data_filter.num_romaneio,
        transportadora: data_filter.transportadora.pessoa_id,
        status: data_filter.status.value,
      };
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.loadingData = true;
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onLoaded: function () {
      this.dataExport = this.$refs.vuetable.tableData;
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onExport(data) {
      this.$refs.gerenciamentotransporteexportacao.onExport(data);
    },
    onAdiantar(data) {
      this.$refs.gerenciamentotransporteadiantamento.onCreate(data);
    },
    onTransferencia(carga_id) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = carga_id;
      this.form
          .post("/api/gerenciamentotransporte/transferenciainterna")
          .then((response) => {
            new ReturnApi(response, this);
            if (this.metodo != null) {
              this.metodo();
            }
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
    },
    onPrintRomaneio(data) {
      this.loading = true;
      this.isDisabled = true;
      this.form.carga_id = data.carga_id;
      this.form
        .post("/api/gerenciamentotransporte/romaneio/imprimir")
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onCreate() {
      this.$refs.gerenciamentotransporteform.onCreate();
    },
    onEdit(data, index) {
      this.id = data.carga_id;
      this.$refs.gerenciamentotransporteform.onEdit(data, index, this.id);
    },
    onActivateDesactivate(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.recordCollection = [];
        this.helpForm.recordCollection.push(data.carga_id);
      } else {
        this.helpForm.recordCollection = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.recordCollection.push(obj);
        });
      }
      this.$refs.gerenciamentotransporteform.onActivateDesactivate(
        this.helpForm
      );
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
  },
};
</script>
